// extracted by mini-css-extract-plugin
export var container = "Warning-module--container--64e30";